'use client';

import React from 'react';
import { Discipline } from '@/lib/types';
import { Calendar } from 'lucide-react';
import Link from 'next/link';

interface DisciplinesProps {
  disciplines: Discipline[];
}

export default function Disciplines({ disciplines }: DisciplinesProps) {
  return (
    <section className="bg-navy py-24 text-white">
      <div className="container mx-auto px-4">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-4xl font-black tracking-tight text-white uppercase">
            Nos Disciplines
          </h2>
          <p className="mx-auto max-w-2xl text-white/60">
            Découvrez la variété de nos cours, du loisir à la haute compétition, pour tous les âges.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {disciplines.map((discipline) => (
            <div
              key={discipline.id}
              className="group bg-navy-light border-navy-light hover:border-red/30 flex flex-col items-center rounded-3xl border p-8 text-center shadow-lg transition-all duration-300 hover:shadow-2xl"
            >
              <div
                className="mb-6 flex h-20 w-20 transform items-center justify-center rounded-2xl text-4xl transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: `${discipline.color}25`, color: discipline.color }}
              >
                {discipline.icon}
              </div>
              <h3 className="mb-3 px-2 text-xl font-black text-white">{discipline.name}</h3>
              <p className="mb-8 flex-grow text-sm text-white/70">{discipline.description}</p>
              <div className="flex w-full">
                <Link
                  href={discipline.url}
                  className="bg-navy hover:bg-red hover:border-red group-hover:shadow-red/20 flex flex-1 items-center justify-center gap-2 rounded-xl border border-white/10 py-4 text-xs font-black tracking-widest text-white uppercase shadow-lg transition-all duration-300 hover:scale-[1.02]"
                >
                  <Calendar size={16} /> Agenda complet
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
